import { Navigate } from "react-router-dom";
import { isPlatformAdminUser } from "../hooks/useIsReseller";

/**
 * Componente que redirige a la sección inicial del admin según el rol.
 * Para los roles de plataforma (owner / admin reseller) redirige a companies,
 * otros a units.
 */
export default function AdminIndexRedirect() {
  const userRole = localStorage.getItem("userRole");

  if (userRole === "admin reseller" || userRole === "owner" || isPlatformAdminUser()) {
    return <Navigate to="/admin/companies" replace />;
  }

  return <Navigate to="/admin/units" replace />;
}
